import { PeoPayrollProviderStaffWrapper } from 'src/components/peoPayrollProviderStaff';
import {
  InvitePeoPayrollProviderStaffByPEOPPModal,
  PeoPayrollProviderStaffDetailsModal,
} from 'src/modals/peoPayrollProviderStaff';
import { TableDataProvider } from 'src/providers/TableDataProvider';

export const PeoPayrollProviderStaff = () => {
  return (
    <TableDataProvider>
      <PeoPayrollProviderStaffWrapper />
      <PeoPayrollProviderStaffDetailsModal />
      <InvitePeoPayrollProviderStaffByPEOPPModal />
    </TableDataProvider>
  );
};
